import React from 'react'

import {
  Field,
  Label,
  RolesInput,
  InputWithSuggestions,
} from 'components/form'

const EditEmployment = ({ customer, employer, name, roles, onChange }) => (
  <React.Fragment>
    <Field>
      <Label htmlFor="employer">Arbeidsgiver</Label>
      <InputWithSuggestions
        id="employer"
        suggestionsType="customer"
        value={employer}
        onChange={e => onChange({ key: 'employer', value: e.target.value })}
        required
      />
    </Field>
    <Field>
      <Label htmlFor="roles">Roller</Label>
      <RolesInput
        id="roles"
        value={roles}
        onChange={roles => onChange({ key: 'roles', value: roles })}
      />
    </Field>
  </React.Fragment>
)

export default EditEmployment



// WEBPACK FOOTER //
// ./src/components/EditExperience/EditEmployment.js